// extracted by mini-css-extract-plugin
export default {"gpa__show_large":"Hidden_gpa__show_large__NcqXW","gpa__show_small":"Hidden_gpa__show_small__kJXtY"};